import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../../redux/blockchain/blockchainActions";
import { fetchData } from "../../redux/data/dataActions";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
function MintForm(props) {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <div className="bg-[#121127] p-5 mt-[250px] rounded-md lg:h-full lg:w-7/12 z-10 flex flex-col justify-between">
      <h1 className="text-white sm:text-4xl text-2xl  md:leading-9 text-center sm:text-[26px] md:text-[36px] lg:text-[48px] ">
        {props.title}
      </h1>

      <div>
        <h1 className="text-white text-2xl text-center sm:text-[16px] md:text-[18px] mt-5  mb-5">
          {props.subtitle}
        </h1>

        <hr />
      </div>
      <p className="text-[#FF9E01] text-center text-[16px] mt-5">
        {props.description}
      </p>
      <div>
        <p className="my-2 text-center text-white">Qty</p>
        <div className="rounded-full flex justify-between bg-[#395e96] py-2 px-5 items-center">
          <AiFillMinusCircle
            size={40}
            onClick={() => decrementMintAmount()}
            className="text-[#fff] cursor-pointer"
          />

          <p className="text-2xl text-center text-white">x{mintAmount}</p>
          <AiFillPlusCircle
            size={40}
            onClick={() => incrementMintAmount()}
            className="text-[#fff] cursor-pointer"
          />
        </div>
      </div>
      {props.showTotalInput && (
        <div>
          <p className="text-center text-white mt-7">Total</p>
          <div className="rounded w-full bg-[#395e96] py-2 px-5 items-center">
            <p className="text-center text-white">{quantity * 80} CRO</p>
          </div>
        </div>
      )}

      <h1 className="mt-2 text-center text-black"> {blockchain.errorMsg}</h1>
      <h1 className="text-center text-white "> {feedback}</h1>

      <div className="flex justify-center pt-2 pb-8">
        {blockchain.account ? (
          <button
            disabled={claimingNft ? 1 : 0}
            onClick={(e) => {
              e.preventDefault();
              claimNFTs();
              getData();
            }}
            class="rounded bg-[#395e96] text-white sm:text-[20px] text-md font-extrabold sm:py-2 p-1 px-4 sm:px-2 w-8/12 lg:w-full md:w-full sm:w-5/12 hover:scale-105 "
          >
            <h1 className="truncate"> {truncate(blockchain.account, 15)}</h1>
          </button>
        ) : (
          <button
            onClick={(e) => {
              e.preventDefault();
              dispatch(connect());
              getData();
            }}
            class="rounded bg-[#395e96] text-white sm:text-[20px] text-md font-extrabold sm:py-2 p-1 px-4 sm:px-2 w-8/12 lg:w-full md:w-full sm:w-5/12 hover:scale-105 "
          >
            Connect Wallet
          </button>
        )}
      </div>
    </div>
  );
}

export default MintForm;
